
import { Options, Vue } from 'vue-class-component';
import { $wallet, Horcrux } from '../services';
import Qr from './Qr.vue';

@Options({
  props: {
    value: {
      default: {},
      required: true,
      type: Object
    },
  },
  components: { Qr }
})
export default class HorcruxPrint extends Vue {

  // props
  value!:Horcrux;
  currentDate: Date = new Date();

  //
  // helpers for typescript
  $refs!: {
    title: HTMLInputElement
  }  

  mounted() {
    this.$refs.title.focus()

  }


  get date() {
    return this.currentDate.toLocaleDateString();
  }

  get location (){
    return document.location.href;
  }
}
